import React from 'react';
import SMFormTextField from './SMFormTextField';
import SMFormValidationMessage from './SMFormValidationMessage';
import SMFormFieldBaseView from 'components/dashboard/form/SMFormFieldBaseView';

class SMFormURLFieldWithError extends SMFormFieldBaseView {
  
  render() {
    
    const fieldClassName = this.errorFieldClassName("form-text", this.props.errorText);
    
    return (
      <div className="form-box">
        <span>http://spacemarket.com/spaces/</span>
        <SMFormTextField
          delegate={this.props.delegate}
          name={this.props.name} 
          value={this.props.value} 
          options={this.props.options} 
          placeholder={this.props.placeholderText} />
        <SMFormValidationMessage name={this.props.name} errorText={this.props.errorText} />
      </div>
    );
  }
}
export default SMFormURLFieldWithError;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormURLFieldWithError.jsx